import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Domu from '../sections/Domu'
import Cenik from '../sections/Cenik'
import Kontakt from '../sections/Kontakt'
import Recenze from '../sections/Recenze'
import Sluzby from '../sections/Sluzby'
import OrganizaceVyuky from '../sections/OrganizaceVyuky'

const Home = () => {
  const location = useLocation()
  const hasScrolledOnLoad = useRef(false)

  useEffect(() => {
    // Scrollování pouze při prvním načtení stránky (direct link)
    if (!hasScrolledOnLoad.current) {
      const path = location.pathname.replace('/', '')
      
      // Pokud je cesta sekce (ne hlavní stránka), scrolluj na ni
      if (path && path !== 'domu') {
        const targetSection = path
        
        setTimeout(() => {
          const element = document.getElementById(targetSection)
          if (element) {
            const headerHeight = window.innerWidth < 768 ? 80 : 100
            const elementPosition = element.offsetTop
            const offsetPosition = elementPosition - headerHeight

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            })
          }
        }, 300) // Trochu delší delay pro jistotu načtení
      }
      
      // Označíme, že jsme už scrollovali při načtení
      hasScrolledOnLoad.current = true
    }
  }, []) // Prázdný dependency array - spustí se pouze při mount

  return (
    <main>
      <section id="domu">
        <Domu />
      </section>
      <section id="sluzby">
        <Sluzby />
      </section>
      <section id="organizace">
        <OrganizaceVyuky />
      </section>
      <section id="cenik">
        <Cenik />
      </section>
      <section id="kontakt">
        <Kontakt />
      </section>
      <section id="recenze">
        <Recenze />
      </section>
    </main>
  )
}

export default Home